/** Comma-separated VITE_SUPER_ADMIN_USER_IDS; legacy VITE_SUPER_ADMIN_USER_ID still accepted. */
export function superAdminUserIds(): number[] {
  const raw = String(
    import.meta.env.VITE_SUPER_ADMIN_USER_IDS
      || import.meta.env.VITE_SUPER_ADMIN_USER_ID
      || '22',
  ).trim()
  return raw
    .split(',')
    .map((s) => Number(s.trim()))
    .filter((n) => Number.isFinite(n) && n > 0)
}

export function isSuperAdminUserId(id: number | null | undefined): boolean {
  if (id == null || !Number.isFinite(Number(id))) return false
  return superAdminUserIds().includes(Number(id))
}
